import { KanbanItemRequiredFields } from '@repo/ui/kanban'

type UpdateStatusInput<T> = KanbanItemRequiredFields<T> & {
  order: number
}

export const reorderKanbanItems = <T extends string | number>(
  newState: KanbanItemRequiredFields<T>[],
  oldState: KanbanItemRequiredFields<T>[]
) => {
  const groupedOldState = oldState.reduce(
    (acc, item) => {
      if (!acc[item.columnId]) {
        acc[item.columnId] = []
      }
      acc[item.columnId].push(item.id.toString())

      return acc
    },
    {} as Record<T, string[]>
  )

  const groupedNewState = newState.reduce(
    (acc, item) => {
      if (!acc[item.columnId]) {
        acc[item.columnId] = []
      }
      acc[item.columnId].push(item.id.toString())
      return acc
    },
    {} as Record<T, string[]>
  )

  const updatedData: UpdateStatusInput<T>[] = []

  Object.keys(groupedNewState).forEach((columnId) => {
    const newItems = groupedNewState[columnId as T]
    const oldItems = groupedOldState[columnId as T] || []

    newItems.forEach((newItem, index) => {
      const oldIndex = oldItems.indexOf(newItem)
      if (oldIndex === -1 || oldIndex !== index) {
        updatedData.push({
          id: Number(newItem),
          columnId: columnId as T,
          order: index + 1
        })
      }
    })
  })

  return updatedData
}
